// extracted by mini-css-extract-plugin
export default {"search-box":"bd_QQ","search-box__input":"bd_QR form-control","search-box__icon":"bd_QS ml-2"};